/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import PageTitle from "../../components/pageTitle/PageTitle";
import { Container } from "@material-ui/core";
import { getCompanyClients } from "../../services/apiservices/client";
import { getCompanyUsers } from "../../services/apiservices/employee";
import dayjs from 'dayjs';
import moment from "moment";
import { calculateDurationInMinutes,filterAppointmentsOnSameDate,formatSelectedDateTime, formatTime, generateAppointmentTypeId, getFormatedDate, getUpcomingDates, isTimeInRange, ValidTime } from "../../services/helpers";
import { getAppoinmentByDates, getOneAppointment, saveAppointment, subscribeToAppointmentsByDates, updateAppointments } from "../../services/apiservices/appoinments";
import CommonContext from "../../hooks/commonContext";
import AuthContext from "../../hooks/authContext";
import { CommonConfirmationDialog, CommonSuccessDialog, ConfirmationApptDialog } from "../../components/DialogComponent/SupplyDataDialog";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getSettings, subscribeToSettings } from "../../services/apiservices/settings";
import AppointmentsCard from "./AppointmentsCard";
import { useToast } from "../../hooks/useToast";

const AppoinmentSchedule = (props) => {
    const commonContext = useContext(CommonContext);
    const auth = useContext(AuthContext);
    const [clientNameList, setClientNameList] = useState([
        { label: "Select One", value: "All" },
    ]);
    const [clientName, setClientName] = useState("All");
    const [clientNames, SetClientNames] = useState();
    const [clientDetails, setClientDetails] = useState();
    const [formData, setFormData] = useState({});
    const [empDetails, setEmpDetails] = useState();
    const [shiftNames, setShiftNames] = useState("Any");
    const [allShiftTasks, setAllShiftTasks] = useState([]);
    const [shiftNamesList, setShiftNamesList] = useState([
        { label: "Select One", value: "Any" },
    ]);
    const [employeeNameList, setEmployeeNameList] = useState([
        { label: "Select One", value: "All" },
    ]);
    const [employeesNames, SetEmployeeNames] = useState();
    const [employeeEmail, setEmployeeEmail] = useState();
    const [employeeTimeZone, setEmployeeTimeZone] = useState();
    const [empNames, setEmpNames] = useState("All");
    const [allEmployees, setAllEmployees] = useState([]);
    const [cancelDialogOpen, setCancelDailogOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [manualDate, setManualDate] = useState(null);
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [unitNumber, setUnitNumber] = useState('');
    const [numberOfTime, setNumberOfTime] = useState();
    const [frequencyData, setFrequencyData] = useState();
    const [appoinments, setAppoinments] = useState([]);
    const [upcomingAppoinments, setUpcomingAppointments] = useState([]);
    const [isInputVisible, setInputVisible] = useState(false);
    const [timeVisible, setTimeVisible] = useState(false);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [aaptData, setApptdata] = useState();
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedDay, setSelectedDay] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);
    const [displayStep, setDisplayStep] = useState(1);
    const [daysInMonth, setDaysInMonth] = useState(Array.from({ length: 31 }, (_, i) => i + 1));
    const [errors, setErrors] = useState({
        clientName: false,
        shiftName: false,
        empName: false,
        date: false,
        startTime: false,
        endTime: false,
        frequency: false,
        numberOfTimes: false,
    });
    const [recurringDates, setRecurringDates] = useState([]);
    const [alert, setAlert] = useState(false);
    const [appointmentType, setAppointmentType] = useState('Recurring Appointment');
    const [loader, setLoader] = useState(false);
    const { appointmentId } = useParams();
    const {toast} = useToast();
    const [editAppointmentData, setEditAppointmentData] = useState();
    const [selectedIds, setSelectedIds] = useState([]);
    const [conflictMap, setConflictMap] = useState({});
    const updateAppointmentData = auth.updateAppointmentData?.matchingAppointments;
    const navigate = useNavigate();
    const [settingsData, setSettingsData] = useState();
    const localClientID = localStorage.getItem('clientId');
    const [startMeridiem, setStartMeridiem] = useState("");
    const [endMeridiem, setEndMeridiem] = useState("");
    const localCompanyId = localStorage.getItem('companyId');
    const companyId = auth?.userProfile?.role === "Client" ? localCompanyId ? localCompanyId : auth?.userProfile?.companyId : auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;
    const clientId = localClientID ? localClientID : auth?.userProfile?.client;
    const location = useLocation();
    const mode = location.state?.mode;

    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const extractMeridiem = (val) => {
        const x = val.toLowerCase();
        if (x.includes("am")) return "am";
        if (x.includes("pm")) return "pm";
        return null;
    };


    const AppointmentsScheduling = async () => {
        try {
            // commonContext?.setLoader(true);
            let editAppointmentData = null;
            const date = moment().tz("America/New_York").startOf("day").format("YYYY-MM-DDTHH:mm:ss"); 
            const fetchData = [
                new Promise((resolve) => getCompanyClients(companyId, (res) => resolve(res || []))),
                new Promise((resolve) => getCompanyUsers(companyId, (res) => resolve(res?.data || []))),
            ];

            const [clientsResponse, employeesResponse] = await Promise.all(fetchData);

            if (appointmentId) {
                editAppointmentData = await getOneAppointment(appointmentId, 'timesheets');
                setEditAppointmentData(editAppointmentData?.appointment);
            }

            const clientRess = auth?.userProfile?.role === "Client" ? clientsResponse?.data?.filter((item) => item?.id === clientId) : clientsResponse?.data;
            const clientRes = clientRess?.filter((item) => item?.status !== false);

            setClientDetails(clientRes);
            setEmpDetails(employeesResponse);

            let allShifts = [];
            const clientNames = clientRes?.filter(client => client?.companyId === companyId)?.map(client => ({
                    value: client?.id,
                    label: client?.clientName,
                    firstName: client?.firstName,
                    lastName: client?.lastName,
                    timeZone: client?.timeZone,
                }));

                // clientRes?.forEach(client => {
                // if (client?.shiftData) {
                //     Object.entries(client.shiftData).forEach(([shiftId, shift]) => {
                //         console.log("sad", shift, shiftId)
                //     Object.values(shift).forEach(task => {
                //         if (task?.tasksList.length > 0) {
                //         allShifts.push({
                //             clientId: client?.id,
                //             shiftLabel: task?.title,
                //             tasks: task?.tasksList
                //         });
                //         }
                //     });
                //     });
                // }
                // })
                clientRes?.forEach((client) => {
                  if (client?.shiftData) {
                    const shiftMap = {};

                    Object.values(client?.shiftData)?.forEach((shift) => {
                      Object.values(shift)?.forEach((task) => {
                        if (task?.tasksList?.length > 0) {
                          const shiftKey = task?.title;
                          if (/opentasks/i.test(shiftKey)) return;
                          if (!shiftMap[shiftKey]) {
                            shiftMap[shiftKey] = {
                              clientId: client?.id,
                              shiftLabel: task?.title,
                              frequency: [],
                              tasks: [],
                            };
                          }

                          if (task?.frequency && !shiftMap[shiftKey]?.frequency?.includes(task?.frequency)) {
                                shiftMap[shiftKey]?.frequency?.push(task.frequency);
                            }

                          task?.tasksList?.forEach((t) => {
                            const tId = t?.taskId || t?.id;
                            if (!shiftMap[shiftKey]?.tasks?.some((existing) => (existing?.taskId || existing?.id) === tId)) {
                                shiftMap[shiftKey]?.tasks?.push({
                                    ...t,
                                    taskId: tId,
                                });
                            }
                          });
                        }
                      });
                    });

                    allShifts.push(...Object.values(shiftMap));
                  }
                });

            setClientNameList([{ label: "Select One", value: "All" }, ...clientNames]);
            setAllShiftTasks(allShifts);

            const employeeNames = employeesResponse
                ?.filter(emp => emp?.companyId === companyId && ((Array.isArray(emp?.role) && emp?.role.includes("Employee")) || emp?.role === "Employee") && !emp?.deleted && emp?.status !== false)
                ?.map(emp => ({
                    value: emp?.id,
                    client: emp?.clients,
                    label: `${emp?.firstName} ${emp?.lastName}`,
                    email: emp?.email,
                    timeZone: emp?.timeZone,
                    employeerole: emp?.employeerole
                }));

            setAllEmployees(employeeNames);

            if (editAppointmentData?.appointment?.userId) {
                const { appointment } = editAppointmentData;
                const clientId = appointment?.clientId;
                const clients = clientRes?.find((item) => item.id === clientId);
                const filteredShifts = allShifts?.filter(shift => shift?.clientId === clientId);
                const selectedShift = allShifts?.find((shift) => shift?.clientId === clientId && shift?.shiftLabel === appointment?.apoointmentDetails?.shiftName);
                if (selectedShift || clients) {
                    setFormData({ ...formData, clients: clients, task: selectedShift?.tasks });
                } else {
                    setFormData({...formData, clients: null, task: null})
                }
                setShiftNamesList([
                  { label: "Select One", value: "Any" },
                  { label: "No Shift", value: "No Shift" },
                    ...filteredShifts?.map((shift) => ({
                        value: shift.shiftLabel,
                        label: shift.shiftLabel,
                      })),
                ]);
                setShiftNames(appointment?.apoointmentDetails?.shiftName || "Any");

                const employeeOptions = employeeNames?.filter((employee) => employee?.employeerole === "Client Team")?.map((employee) => {
                    // const isAssigned = employee?.client?.some(
                    //     (client) => client?.clientid === clientId
                    // );
                    return {
                        ...employee,
                    };
                });
                setEmployeeNameList([{ label: "Select One", value: "All" }, ...employeeOptions]);

                setEmpNames(appointment?.userId || "All");
                setDisplayStep(4);
                setClientName(clientId || "All");
                setSelectedDate(dayjs(appointment?.apoointmentDetails?.date) || null);
                setStartTime(formatTime(appointment?.apoointmentDetails?.time) || '');
                setEndTime(formatTime(appointment?.apoointmentDetails?.endTime) || '');
                setStartMeridiem(extractMeridiem(appointment?.apoointmentDetails?.time) || '');
                setEndMeridiem(extractMeridiem(appointment?.apoointmentDetails?.endTime) || '');
                setFrequencyData(appointment?.apoointmentDetails?.frequency || null);
                setNumberOfTime(appointment?.apoointmentDetails?.numberOfTimes ? 2 : null);
                setUnitNumber(appointment?.apoointmentDetails?.unitNumber || '')
                setAppointmentType(appointment?.apoointmentDetails?.type === "Recurring Appointment" && mode === "this"  ? "One Time" : appointment?.apoointmentDetails?.type || "Recurring Appointment");
            } else {
                setShiftNamesList([{ label: "Select One", value: "Any" }]);
                setEmployeeNameList([{ label: "Select One", value: "All" }]);
            }
        } catch (error) {
            console.error("Error in AppointmentsScheduling:", error);
        }
        // commonContext?.setLoader(false);
    }; 


    const resetAll = async () => {
        setDisplayStep(1);
        setClientName("All");
        setShiftNames("Any");
        setEmpNames("All");
        setSelectedDate();
        setStartTime('');
        setEndTime('');
        setAppointmentType("Recurring Appointment");
        setInputVisible(false);
        setFrequencyData();
        setNumberOfTime();
        setIsDialogOpen(false);
        setUpcomingAppointments([]);
        setAppoinments([])
        setManualDate(null);
        setTimeVisible(false);
        setEmployeeTimeZone();
        setRecurringDates([]);
        setSettingsData();
        setApptdata();
        setEditAppointmentData();
        setFormData({});
        auth.setUpdateAppointmentData({});
    };

    useEffect(() => {
        const fetchAppointments = async () => {
            if (appointmentId) {
                await AppointmentsScheduling();
            } else {
                await resetAll();
                await AppointmentsScheduling();
            }
        }

        fetchAppointments();
    }, [appointmentId]);

    useEffect(() => {
        const date = moment().tz("America/New_York").startOf("day").format("YYYY-MM-DDTHH:mm:ss"); 
    
        const unsubscribe = subscribeToAppointmentsByDates(
          date,
          null,
          companyId,
          null,
          (appointments) => {
            setAppoinments(appointments);
          },
          (error) => console.log(error)
        );
    
        return () => unsubscribe && unsubscribe();
      }, [companyId]);
    

    useEffect(() => {
        const unsubscribe = subscribeToSettings(
            companyId,
            "appointment_settings",
            (newSettings) => {
            setSettingsData(newSettings);
            },
            (err) => console.log(err)
        );

        return () => unsubscribe && unsubscribe();
    }, [companyId]);


    useEffect(() => {
     if (startTime && endTime) {
        if (Array.isArray(appoinments) && appoinments?.length > 0) {
            const startime = formatTime(startTime);
            const endtime = formatTime(endTime);
            const filteredAppointments = filterAppointmentsOnSameDate(appoinments, clientName, selectedDate, startime, endtime, empNames);
             if (appointmentId) {
                const data = filteredAppointments?.filter((item) => item?.id !== appointmentId);
                const details = alert && data?.length > 0 ? data : [];
                setUpcomingAppointments(details);
             } else {
                 setUpcomingAppointments(filteredAppointments?.length > 0 ? filteredAppointments : []);
             }
        } else {
            setUpcomingAppointments([]);
        }
     } else {
        setUpcomingAppointments([]);
     }
    },[startTime, endTime])

    const resetDependentFields = () => {
        setRecurringDates([]);
        setStartTime('');
        setEndTime('');
        setFrequencyData();
        setNumberOfTime();
    };

    const handleClientNameChange = (e) => {
        const selectedClientId = e;
        setClientName(selectedClientId);
        if (!appointmentId) {
            resetDependentFields();
        }
        const isClientNameError = selectedClientId === "All";
        setErrors((prevErrors) => ({ ...prevErrors, clientName: isClientNameError }));

        if (selectedClientId === "All") {
            setShiftNamesList([{ label: "Select One", value: "Any" }]);
            setUpcomingAppointments([]);
            setEmpNames("All");
        } else {
            const selectedClient = clientNameList?.find((client) => client.value === selectedClientId);
            const clients = clientDetails?.find((item) => item.id === selectedClientId);
            setFormData({ ...formData, clients: clients, task: null});
            setUnitNumber('')
            if (selectedClient) {
                SetClientNames(selectedClient);
            } else {
                SetClientNames();
            }
        }

        const filteredShifts = allShiftTasks?.filter(
            (shift) => shift?.clientId === selectedClientId
        );

        const shiftOptions = [
        { label: "Select One", value: "Any" },
        { label: "No Shift", value: "No Shift" },
        ...filteredShifts?.map((shift) => ({
                value: shift.shiftLabel,
                label: shift.shiftLabel,
            }))
        ];

        setShiftNamesList(shiftOptions);
        setShiftNames("Any");

        const filteredEmployees = allEmployees?.map((employee) => {
            // const isAssigned = employee?.client?.some(
            //     (client) => client?.clientid === selectedClientId
            // );
            return {
                ...employee,
                // isAssigned: !!isAssigned,
            };
        });

        const employeeOptions = [
            { label: "Select One", value: "All" },
            ...filteredEmployees?.filter((employee) => employee?.employeerole === "Client Team")?.map((employee) => ({
                value: employee?.value,
                label: employee?.label,
                email: employee?.email,
                timeZone: employee?.timeZone,
                employeerole: employee?.employeerole
                // apptEmp: employee.isAssigned
            }))
        ];

        setEmployeeNameList(employeeOptions);
        setEmpNames("All");
    }

    // const filterAppointmentOnTheDate = (times) => {
    //     if (Array.isArray(appoinments?.appointments) && appoinments?.appointments.length > 0) {
    //         const startime = formatTime(startTime);
    //         const endtime = formatTime(times);
    //         const filteredAppointments = filterAppointmentsOnSameDate(appoinments, clientName, selectedDate, startime, endtime, empNames);
    //         setUpcomingAppointments(filteredAppointments?.length > 0 ? filteredAppointments : []);
    //     } else {
    //         setUpcomingAppointments([]);
    //     }
    // };

    const handleShiftNameChange = (selectedOption) => {
        const selectedShift = allShiftTasks?.find((shift) => shift?.clientId === clientName && shift?.shiftLabel === selectedOption);
        setShiftNames(selectedOption);
        if (selectedShift) {
            setFormData({ ...formData, task: selectedShift?.tasks });
        }else {
            setFormData({...formData, task: null})
        }
        if (!appointmentId) {
            resetDependentFields();
        }
        const isShiftNameError = selectedShift === "Any";
        setErrors((prevErrors) => ({ ...prevErrors, shiftName: isShiftNameError }));
    };

    const handleEmpNameChange = (e) => {

        const selectEmployee = e;
        setEmpNames(selectEmployee);
        if (!appointmentId) {
            resetDependentFields();
        }
        const isEmpNameError = selectEmployee === "All";
        setErrors((prevErrors) => ({ ...prevErrors, empName: isEmpNameError }));

        if (selectEmployee !== "All") {
            const selectedEmployee = employeeNameList?.find((employee) => employee.value === selectEmployee);

            if (selectedEmployee) {
                SetEmployeeNames(selectedEmployee?.label);
                setEmployeeEmail(selectedEmployee?.email);
                setEmployeeTimeZone(selectedEmployee?.timeZone);
            }
        } else {
            SetEmployeeNames('');
            setEmployeeEmail('');
            setEmployeeTimeZone('');
            setSelectedDate();
            setSelectedMonth(null);
            setSelectedDay(null);
            setSelectedYear(null);
            setDaysInMonth([]);
            setManualDate();
        }
    };

    const handelancelData = () => {
        setCancelDailogOpen(true);
    }
    const handelOpenDialog = async () => {
        setCancelDailogOpen(false);
        await resetAll();
        await AppointmentsScheduling();
    }
    const handelCloseDialog = () => {
        setCancelDailogOpen(false);
    }
    const handelConfirmCloseDialog = () => {
        setConfirmDialogOpen(false);
    }
    const handelSingleApptConfirmDialog = async () => {
        const dates = [recurringDates[0]];
        const ids = selectedIds;
        setConfirmDialogOpen(false);
        setLoader(true);
        const prevHistory = editAppointmentData?.apoointmentDetails?.historyDate || [];

        const updatedHistory = prevHistory.includes(editAppointmentData?.appointmentDateTime)
            ? prevHistory
            : [...prevHistory, editAppointmentData?.appointmentDateTime];
        
         const updatedApptData = {
            ...aaptData,
            historyDate: updatedHistory,
         }
         const type = mode || "this";
        // if (recurringDates && recurringDates.length > 0) {
        if (appointmentType === "Recurring Appointment") {
            const response = await updateAppointments(aaptData, recurringDates, ids, type);
            if (response.success) {
                setIsDialogOpen(true);
                setApptdata();
                setLoader(false);
            } else {
                console.error("Failed to save appointment:", response.error);
                setApptdata();
            }
        } else {
            const response = await updateAppointments(updatedApptData, recurringDates, editAppointmentData?.id, type);
            if (response.success) {
                setIsDialogOpen(true);
                setApptdata();
                setLoader(false);
            } else {
                console.error("Failed to save appointment:", response.error);
                setApptdata();
            }
            // setFrequencyData();
            // setNumberOfTime();
            // setLoader(false);
            // const newErrors = {
            //     frequency: true,
            //     numberOfTimes: true
            // };
            // setErrors(newErrors);
        }
    }

    const handelSeriesApptConfirmDialog = async () => {
        const apptids = updateAppointmentData?.map(item => item.id) || [];
        setConfirmDialogOpen(false);
        setLoader(true);
        if (recurringDates && recurringDates.length > 0) {
            const response = await updateAppointments(aaptData, recurringDates, apptids);
            if (response.success) {
                setIsDialogOpen(true);
                setLoader(false);
                setApptdata();
            } else {
                console.error("Failed to save appointment:", response.error);
                setApptdata();
                setLoader(false);
            }
        } else {
            setFrequencyData();
            setNumberOfTime();
            setLoader(false);
            const newErrors = {
                frequency: true,
                numberOfTimes: true
            };
            setErrors(newErrors);
        }
    }

    const handelSuccelCloseDialog = async () => {
        setIsDialogOpen(false);
        toast?.({
            title: "Success",
            description: appointmentId ? "Appointment Updated Successfully" : "Appointment Created Successfully",
            variant: "default",
        });

        if (appointmentId) {
            await resetAll();
            navigate("/operations/manageAppointments");
        } else {
            await resetAll();
            await AppointmentsScheduling();
        }
    };

    const handleCancelTime = () => {
        if (appointmentId) {
            setRecurringDates([]);
        } else {
            setSelectedDate();
            setStartTime('');
            setEndTime('');
            setFrequencyData();
            setNumberOfTime();
            setManualDate(null);
            setRecurringDates([]);
        }
    };

    const handleAddTime = () => {
        if (appointmentType === "Recurring Appointment") {
            const isStartTimeInRange = isTimeInRange(startTime, settingsData?.startTime, settingsData?.endTime);
            const isEndTimeInRange = isTimeInRange(endTime, settingsData?.startTime, settingsData?.endTime);

            const newErrors = {
                date: !(selectedDate || manualDate),
                startTime: {
                    hasError: !startTime || !isStartTimeInRange || !ValidTime(startTime),
                    text: !startTime ? "Choose One" : 
                          !isStartTimeInRange ? "Start time is out of range" : 
                          !ValidTime(startTime) ? "Invalid start time format" : ""
                },
                endTime: {
                    hasError: !endTime || !isEndTimeInRange || !ValidTime(endTime),
                    text: !endTime ? "Choose One" : 
                          !isEndTimeInRange ? "End time is out of range" : 
                          !ValidTime(endTime) ? "Invalid end time format" : ""
                },
                frequency: frequencyData ? !frequencyData : false,
                numberOfTimes: numberOfTime < 2 ? true : !numberOfTime,
                manualDate: !(selectedDate || manualDate),
                clientName: clientName === "All",
                shiftName: shiftNames === "Any",
                empName: empNames === "All"
            };

            const hasErrors = Object.values(newErrors).some(err => {
                if (typeof err === "boolean") return err;
                if (typeof err === "object") return err.hasError;
                return false;
            });

            if (hasErrors) {
                setErrors(newErrors);
                setLoader(false);
                return;
            }
            const workWeek = settingsData?.workWeek ? settingsData?.workWeek : null;
            if (manualDate) {
                const newDates = getUpcomingDates(manualDate, frequencyData, numberOfTime, workWeek);
                setRecurringDates(newDates);
            } else {
                const newDate = getUpcomingDates(selectedDate, frequencyData, numberOfTime, workWeek);
                setRecurringDates(newDate);
            }
        } else {
            setRecurringDates([]);
        }
    };

    const handleRemoveDate = (dateToRemove) => {
        const formattedDate = moment(dateToRemove, "MM/DD/YYYY").format("MMMM D, YYYY");
        setRecurringDates(prevDates => prevDates?.filter(date => date !== dateToRemove));
        setUpcomingAppointments(prevAppointments => prevAppointments?.filter(app => app?.date !== formattedDate));
        setSelectedIds(prev => prev?.slice(0, -1));

        setConflictMap(prev => {
            if (!prev[formattedDate]) return prev; 
            const newMap = { ...prev };
            delete newMap[formattedDate];
            return newMap;
        });
    };
    const handelNavigate = async () => {
        await resetAll();
        navigate("/operations/manageAppointments");
    };
           
    const dateCreated = moment().format('MMMM DD, YYYY');
    const datetimeCreated = moment().format('YYYY-MM-DDTHH:mm:ssZ');
    const appointmentTypeId = generateAppointmentTypeId();
    const appointmentDuration = calculateDurationInMinutes(startTime, endTime);
    const date = getFormatedDate(selectedDate);
    const selectedClient = clientNameList?.find(client => client.value === clientName);
    const selectedShift = shiftNamesList?.find(shift => shift.value === shiftNames);
    const selectedEmployee = employeeNameList?.find(emp => emp.value === empNames);
    const timeZone = employeeTimeZone || selectedEmployee?.timeZone || null;
    const dateTimes = formatSelectedDateTime(selectedDate, startTime, timeZone);

    const handleAddAppointments = async () => {
        setLoader(true);
        const normalizedStartTime = formatTime(startTime);
        const normalizedEndTime = formatTime(endTime);

         if (normalizedStartTime === "Invalid time") {
            setErrors(prev => ({ ...prev, startTime: true, text: `"${startTime}" is invalid` }));
            setLoader(false);
            return;
        }

        if (normalizedEndTime === "Invalid time") {
            setErrors(prev => ({ ...prev, endTime: true, text: `"${endTime}" is invalid` }));
            setLoader(false);
            return;
        }

        const isStartTimeInRange = isTimeInRange(startTime, settingsData?.startTime, settingsData?.endTime);
        const isEndTimeInRange = isTimeInRange(endTime, settingsData?.startTime, settingsData?.endTime);

        const newErrors = {
            date: !(selectedDate || manualDate),
            startTime: {
                hasError: !startTime || !isStartTimeInRange || !ValidTime(startTime),
                text: !startTime ? "Start time is required" : 
                      !isStartTimeInRange ? "Start time is out of range" : 
                      !ValidTime(startTime) ? "Invalid start time format" : ""
            },
            endTime: {
                hasError: !endTime || !isEndTimeInRange || !ValidTime(endTime),
                text: !endTime ? "End time is required" : 
                      !isEndTimeInRange ? "End time is out of range" : 
                      !ValidTime(endTime) ? "Invalid end time format" : ""
            },
            frequency: appointmentType === "Recurring Appointment" && !frequencyData,
            numberOfTimes: appointmentType === "Recurring Appointment" && !numberOfTime,
            manualDate: !(selectedDate || manualDate),
            clientName: clientName === "All",
            shiftName: shiftNames === "Any",
            empName: empNames === "All",
        };

        const hasErrors = Object.values(newErrors).some(error => error === true);

        if (hasErrors) {
            setErrors(newErrors);
            setLoader(false);
            return;
        }

        try {
            const manualDates = manualDate && dayjs.isDayjs(manualDate) && manualDate.isValid()
                ? manualDate.format('MMMM D, YYYY')
                : null;
            const startTimes = (startTime && isTimeInRange(startTime, settingsData?.startTime, settingsData?.endTime) && ValidTime(startTime)) ? startTime : null;
            const manualDateTimes = manualDate && dayjs.isDayjs(manualDate) && manualDate.isValid()
                ? formatSelectedDateTime(manualDate, startTimes, timeZone)
                : null;

            const type = editAppointmentData?.apoointmentDetails?.type;
            const newAppointmentTypeId = editAppointmentData && (type === "One Time" || (type === "Recurring Appointment" && mode === "this")) ? editAppointmentData?.apoointmentDetails?.appointmentTypeID : appointmentTypeId;
            const newDateTimeCreated = editAppointmentData && (type === "One Time" || (type === "Recurring Appointment" && mode === "this")) ? editAppointmentData?.apoointmentDetails?.datetimeCreated : datetimeCreated;
            const newDateCreated = editAppointmentData && (type === "One Time" || (type === "Recurring Appointment" && mode === "this")) ? editAppointmentData?.apoointmentDetails?.dateCreated : dateCreated;
            const companyId = auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;

                const newAppointmentData = {
                appointmentTypeID: newAppointmentTypeId || appointmentTypeId,
                appointmentDateTime: manualDateTimes || dateTimes,
                calendar: employeesNames || selectedEmployee?.label,
                clientId: clientName,
                date: manualDates || date,
                datetimeCreated: newDateTimeCreated || datetimeCreated,
                dateCreated: newDateCreated || dateCreated,
                duration: appointmentDuration,
                email: employeeEmail || selectedEmployee?.email,
                endTime: normalizedEndTime,
                firstName: clientNames?.firstName || selectedClient?.firstName,
                scheduledBy: auth?.userProfile?.email,
                frequency: frequencyData || "",
                lastName: clientNames?.lastName || selectedClient?.lastName,
                time: normalizedStartTime,
                type: appointmentType,
                numberOfTimes: appointmentType === "One Time" ? 2 : numberOfTime,
                userId: empNames || selectedEmployee?.value,
                shiftName: shiftNames || selectedShift,
                calendarTimezone: employeeTimeZone || selectedEmployee?.timeZone || null,
                companyId: companyId,
                unitNumber: unitNumber
            };
            setApptdata(newAppointmentData);
            if (editAppointmentData && editAppointmentData !== undefined) {
                if (appointmentType === "One Time") {
                    setConfirmDialogOpen(true);
                    // const response = await updateAppointments(newAppointmentData, recurringDates, editAppointmentData?.id);
                    // if (response.success) {
                    //     setIsDialogOpen(true);
                    // } else {
                    //     console.error("Failed to save appointment:", response.error);
                    // }
                } else {
                    setConfirmDialogOpen(true);
                }
            } else {
                if (appointmentType === "Recurring Appointment") {
                    if (recurringDates && recurringDates.length > 0) {
                        const response = await saveAppointment(newAppointmentData, recurringDates);
                        if (response.success) {
                            setIsDialogOpen(true);
                        } else {
                            console.error("Failed to save appointment:", response.error);
                        }
                    } else {
                        setFrequencyData();
                        setNumberOfTime();
                        const newErrors = {
                            frequency: true,
                            numberOfTimes: true
                        };
                        setErrors(newErrors);
                    }
                } else {
                    const response = await saveAppointment(newAppointmentData);
                    if (response.success) {
                        setIsDialogOpen(true);
                    } else {
                        toast?.({
                            title: "Error",
                            description: appointmentId ? "Failed to update appointment:" : "Failed to save appointment:",
                            variant: "destructive",
                        });
                        console.error("Failed to save appointment:", response.error);
                    }
                }
            }

            setLoader(false);
        } catch (error) {
            console.error("Error in handleAddAppointments:", error);
            setLoader(false);
        }
    };

    const hasTimeZoneConflict = clientNames?.timeZone && employeeTimeZone && clientNames?.timeZone !== employeeTimeZone;

    const checkInTime = editAppointmentData?.checkInDateTime?.seconds 
    ? moment.unix(editAppointmentData.checkInDateTime.seconds).tz(editAppointmentData?.apoointmentDetails?.calendarTimezone).format("hh:mm a") : null;
    
    const checkOutTime = editAppointmentData?.checkOutDateTime?.seconds 
    ? moment.unix(editAppointmentData.checkOutDateTime.seconds).tz(editAppointmentData?.apoointmentDetails?.calendarTimezone).format("hh:mm a") : null;

    const DateTimeProps = {
        empNames, selectedDate, setSelectedDate, startTime, setStartTime, endTime, setEndTime, frequencyData, setFrequencyData, numberOfTime, setNumberOfTime, isInputVisible,
        setInputVisible, timeVisible, setTimeVisible, errors, setErrors, appointmentType, manualDate, setManualDate, handleAddTime, setRecurringDates, handleCancelTime,
        selectedMonth, selectedDay, selectedYear, setSelectedYear, setSelectedDay, setSelectedMonth, daysInMonth, setDaysInMonth, 
        editAppointmentData, settingsData, appointmentId, setSelectedIds, selectedIds, startMeridiem, setStartMeridiem, endMeridiem, setEndMeridiem, setAlert
    }

    const appointmentsProps = {
        clientName, shiftNames, empNames, formData, setUnitNumber, unitNumber, appointmentId, appointmentType, setAppointmentType, displayStep, setDisplayStep, handleClientNameChange, checkInTime, checkOutTime, clientNameList,
        handleShiftNameChange, shiftNamesList, handleAddAppointments, loader, hasTimeZoneConflict , recurringDates, upcomingAppoinments, selectedClient, selectedEmployee, startTime, endTime,
        selectedDate, handleRemoveDate, errors, employeeNameList, handleEmpNameChange, appoinments, frequencyData, numberOfTime, settingsData, setErrors, clientDetails, empDetails, selectedIds, editAppointmentData, conflictMap, setConflictMap
    }    

    return (
        <>
            <Container>
                <PageTitle
                    pageTitle={`${appointmentId ? "ReSchedule Work" : "Schedule Appointment"}`}
                    showBreadcrumb={[
                        { label: "Home", to: "/" },
                        { label: "Appointments", to: "/operations/manageAppointments" },
                    ]}
                    BreadCrumbCurrentPageTitle={`${appointmentId ? "ReSchedule Work" : "Schedule Work"}`}
                    showLastSeen={true}
                />
                <AppointmentsCard appointmentProps={appointmentsProps} DateTimeProps={DateTimeProps} />
            </Container>
            <CommonConfirmationDialog
                open={cancelDialogOpen}
                onConfirm={handelOpenDialog}
                onClose={handelCloseDialog}
                title={"Cancel Appoinment"}
                meessge={"Are You Sure You Want To Cancel This Appoinment ?"}
                buttonTitle={"Yes"}
            />
            {isDialogOpen && (
                <CommonSuccessDialog 
                    open={isDialogOpen} 
                    onClose={handelSuccelCloseDialog} 
                    title={appointmentId ? "Appointment Updated Successfully"  :"Appointment Scheduled"} 
                    message={appointmentId ? "Your appointment has been updated successfully. We're here to help you stay on track." : "Your appointment has been scheduled successfully. We look forward to seeing you soon."}
                />
            )}
            {confirmDialogOpen && (
                <ConfirmationApptDialog open={confirmDialogOpen} onSingleAppt={handelSingleApptConfirmDialog} onConfirm={handelSeriesApptConfirmDialog} modal={appointmentId}
                    auth={editAppointmentData} update={updateAppointmentData} onClose={handelConfirmCloseDialog} client={clientNameList} data={aaptData} />
            )}
        </>
    );
}

export default AppoinmentSchedule;